import styles from './Tnc.module.scss'

export const TermsAndConditions = () => {
    const tnc = [
        'Jigsaw Financial Technology Private Limited ("Merito") shall always store and process such data and information in a secure manner and shall not disclose it to third parties.',
        'You accept, agree and undertake that by providing your login and access credentials to Merito for the relevant platform, sales channel, marketplace etc.,',
        '(i) you are the lawful and registered owner of the relevant account and are authorized to provide such credentials,',
        '(ii) Merito may use such credentials to extract, copy, record and download such data and information on such account as already indicated to you,',
        '(iii) you shall indemnify, defend and hold harmless Merito and its shareholders, directors, officers and employees from all losses, claims, demands and amounts suffered and incurred by them in connection with the any breach of the foregoing by you, and',
        '(iv) Merito shall not be liable in any manner whatsoever with respect to the operation of the relevant platform, sales channel, marketplace etc.'
    ]
    return (
        <div className={styles.container}>
            {
                tnc.map(para => (
                    <>
                        <p>{para}</p>
                        <br />
                    </>
                ))
            }
        </div>
    )
}